import axiosInstance from "./axiosInstance";

const BANKS_BASE_URL = "/banks";
const BANK_ACCOUNT_VERIFY_URL = "/merchant/bank-account/verify";
// FUTURE RELEASE: MSISDN bank verification endpoint — re-enable when phone number verification is supported
// const BANK_ACCOUNT_VERIFY_MSISDN_URL = "/merchant/bank-account/verify-via-msisdn";

const banksService = {
  fetchBanks: async () => {
    const response = await axiosInstance.get(BANKS_BASE_URL);
    return response.data;
  },

  verifyBankAccount: async (payload) => {
    const response = await axiosInstance.post(BANK_ACCOUNT_VERIFY_URL, payload);
    return response.data;
  },

  // FUTURE RELEASE:Re-enable verifyBankAccountViaMsisdn and BANK_ACCOUNT_VERIFY_MSISDN_URL above when supported.
  // verifyBankAccountViaMsisdn: async (payload) => {
  //   const response = await axiosInstance.post(BANK_ACCOUNT_VERIFY_MSISDN_URL, payload);
  //   return response.data;
  // },
};

export default banksService;
